export { default } from 'i18next-browser-languagedetector';
